module.exports = __webpack_public_path__ + "static/media/et_10.348c7d74.png";